enum RoutingPaths {
  SigninPath = "/login",
  SigninPath2 = "/sign-in",
  ResetPassword = "/login/resetPassword",
  AppDashboard = "/",
  FundList = "/funds",
  FundNav = "/fund-nav/*/:fundId",
  FundDetails = "/fund-nav/fund-details",
  FundInvestorList = "/fund-nav/fund-investors",
  JournalEntries = "/fund-nav/journal-entries",
  TransactionMapper = "/fund-nav/transaction-mapper",
  FundAllocationsList = "/fund-nav/fund-allocations-list",
  FundAllocationsFile = "/fund-nav/fund-allocations-list-file",
  FundPortfolioCompanies = "/fund-nav/portfolio-companies",
  Investors = "/investors",
  Contacts = "/contacts",
  Transactions = "/transactions",
  NewTransactions = "/transactions/new",
  EditTransactions = "/transactions/:transactionId",
  CapitalAccounts = "/capital-accounts",
  Documents = "/documents",
  Mailings = "/mailings",
  CapitalCalls = "/capital-calls",
  ClientPortalCapitalCalls = "/portal/capital-calls",
  CapitalCallDetails = "/capital-calls/:id/:section",
  Distributions = "/distributions",
  ClientPortalDistributions = "/portal/distributions",
  DocumentDownload = "/portal/documents/:document_id",
  ReportDownload = "/portal/downloads/:report_id",
  DistributionsDetails = "/distributions/:id/:section",
  Reports = "/reports",
  Teams = "/teams",
  UploadHistory = "/upload-history",
  DownloadHistory = "/download-history",
  Users = "/users",
  Clients = "/clients",
  ClientsDetails = "/clients/:id/:arkTag/:section",
  PortfolioInvestments = "/portfolio-investments",
  ScheduleOfInvestments = "/schedule-of-investments",
  ScheduleOfInvestmentsFund = "/fund-nav/schedule-of-investments",
  Portfolio = "/portfolio",
  InvestmentTransactions = "/investment-transactions",
  InvestmentTransactionsFund = "/fund-nav/investment-transactions",
}

export default RoutingPaths;
